import React, { useState } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa"; // npm install react-icons

export default function SVTableDiscounts({ data }) {
  const [expanded, setExpanded] = useState({});

  const dataGrouped = groupByDiscount(data);

  function groupByDiscount(tickets) {
    const groups = {};

    for (const t of tickets) {
      const id = t["Discount Name"] || "Entrada general";

      if (!groups[id]) {
        groups[id] = {
          name: id,
          type: t["Discount Type"],
          discountAmount: t["Discount Amount"],
          AmountTotal: 0,
          NumEntrades: 0,
          Entradas: [],
        };
      }

      groups[id].Entradas.push(t);
      groups[id].AmountTotal += Number(t.Amount || 0);
      groups[id].NumEntrades += 1;
    }

    return Object.values(groups);
  }

  return (
    <>
      <h5> Descomptes</h5>
      <table className="table table-hover table-bordered align-middle">
        <thead className="table-light">
          <tr>
            <th style={{ width: "40px" }}></th>
            <th>Nom</th>
            <th>Núm.</th>
            <th>Descompte</th>
            <th className="text-end">Import</th>
          </tr>
        </thead>

        <tbody>
          {dataGrouped.map((discount, idx) => (
            <React.Fragment key={idx}>
              <tr
                onClick={() =>
                  setExpanded((prev) => ({ ...prev, [idx]: !prev[idx] }))
                }
                style={{
                  cursor: "pointer",
                  backgroundColor: idx % 2 === 0 ? "#f9f9f9" : "white",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#e8f4ff")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor =
                    idx % 2 === 0 ? "#f9f9f9" : "white")
                }
              >
                <td className="text-center" style={{ width: "40px" }}>
                  {expanded[idx] ? <FaChevronDown /> : <FaChevronRight />}
                </td>
                <td>{discount.name}</td>
                <td>{discount.NumEntrades}</td>
                <td>
                  {discount.type === "Percent"
                    ? discount.discountAmount + " %"
                    : discount.discountAmount + " €"}
                </td>

                <td className="text-end">
                  {discount.AmountTotal?.toFixed(2)} €
                </td>
              </tr>

              {expanded[idx] && (
                <tr>
                  <td colSpan="6" className="p-0">
                    <table className="table table-sm mb-0">
                      <thead className="table-secondary">
                        <tr>
                          <th>Fila/Seient</th>
                          <th>Nom</th>
                          <th>Obra</th>
                          <th>Sesió</th>
                          <th className="text-end">Import</th>
                        </tr>
                      </thead>
                      <tbody>
                        {discount.Entradas.map((t, i) => (
                          <tr
                            key={i}
                            style={{
                              cursor: "pointer",
                              backgroundColor:
                                i % 2 === 0 ? "#f9f9f9" : "white",
                              transition: "background-color 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#e8f4ff")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                i % 2 === 0 ? "#f9f9f9" : "white")
                            }
                          >
                            <td>{t.Fila + "/" + t.Seient}</td>
                            <td>{t.Name}</td>
                            <td>{t.Show}</td>
                            <td>{t.Session}</td>
                            <td className="text-end">
                              {t.Amount?.toFixed(2)} €
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </>
  );
}
